<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :rowButtonAction="rowButtonAction"
                :showModeOpenId="showModeOpenId"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <AgreementForm :formProps="formProps">
                </AgreementForm>
            </template>
            <template #search="searchProps">
                <AgreementSearch :searchProps="searchProps">
                </AgreementSearch>
            </template>

        </v-view>
    </div>
</template>

<script setup>
import AgreementForm from './AgreementForm.vue'
import AgreementSearch from './AgreementSearch.vue'
import { rowButtonAction } from '@pages/Helper/crud_utils.js'
import { getFromUrl } from '@pages/Helper/utils.js';
import { ref } from "vue";

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
})

const selectedRows = ref([])
const showModeOpenId = getFromUrl()

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
